var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 506,
    viewBox: "0 0 506 506",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 253,
    r: 187.43,
    stopColor: "#000000",
    stroke: "#fff",
    strokeMiterlimit: 1,
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m253 5c-137 0-248 111-248 248s111 248 248 248c137 0 248-111 248-248s-111-248-248-248zm121.6 313.1c4.7 4.7 4.7 12.3 0 17l-39.6 39.5c-4.7 4.7-12.3 4.7-17 0l-65-65.6-65.1 65.6c-4.7 4.7-12.3 4.7-17 0l-39.5-39.6c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17l-65.7 65z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitButton);
export default __webpack_public_path__ + "static/media/exit-button.2ffb23da12aa2b7470addbb41705c3a3.svg";
export { ForwardRef as ReactComponent };